/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrokerAbpInfos } from './BrokerAbpInfos';
import {
    BrokerAbpInfosFromJSON,
    BrokerAbpInfosFromJSONTyped,
    BrokerAbpInfosToJSON,
    BrokerAbpInfosToJSONTyped,
} from './BrokerAbpInfos';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface BrokerDto
 */
export interface BrokerDto {
    /**
     * Unique identifier of the broker
     * @type {string}
     * @memberof BrokerDto
     */
    id: string;
    /**
     * Unique identifier of the legal entity (personne morale)
     * @type {string}
     * @memberof BrokerDto
     */
    legalEntityId: string;
    /**
     * Company name (designation)
     * @type {string}
     * @memberof BrokerDto
     */
    companyName: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof BrokerDto
     */
    address: AddressDto;
    /**
     * Email address for complaints (réclamation)
     * @type {string}
     * @memberof BrokerDto
     */
    complaintEmail: string;
    /**
     * Phone number
     * @type {string}
     * @memberof BrokerDto
     */
    phone: string;
    /**
     * SIRET number
     * @type {string}
     * @memberof BrokerDto
     */
    registrationNumber: string;
    /**
     * Company capital
     * @type {number}
     * @memberof BrokerDto
     */
    capital: number;
    /**
     * RCS registration city
     * @type {string}
     * @memberof BrokerDto
     */
    rcsCity?: string;
    /**
     * RCS registration number
     * @type {string}
     * @memberof BrokerDto
     */
    rcsNumber?: string;
    /**
     * ORIAS number if available
     * @type {string}
     * @memberof BrokerDto
     */
    oriasNumber?: string | null;
    /**
     * Professional liability insurance (Responsabilité Civile Professionnelle)
     * @type {string}
     * @memberof BrokerDto
     */
    rcp?: string | null;
    /**
     * 
     * @type {BrokerAbpInfos}
     * @memberof BrokerDto
     */
    brokerUser: BrokerAbpInfos;
}

/**
 * Check if a given object implements the BrokerDto interface.
 */
export function instanceOfBrokerDto(value: object): value is BrokerDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('complaintEmail' in value) || value['complaintEmail'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('capital' in value) || value['capital'] === undefined) return false;
    if (!('brokerUser' in value) || value['brokerUser'] === undefined) return false;
    return true;
}

export function BrokerDtoFromJSON(json: any): BrokerDto {
    return BrokerDtoFromJSONTyped(json, false);
}

export function BrokerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'legalEntityId': json['legalEntityId'],
        'companyName': json['companyName'],
        'address': AddressDtoFromJSON(json['address']),
        'complaintEmail': json['complaintEmail'],
        'phone': json['phone'],
        'registrationNumber': json['registrationNumber'],
        'capital': json['capital'],
        'rcsCity': json['rcsCity'] == null ? undefined : json['rcsCity'],
        'rcsNumber': json['rcsNumber'] == null ? undefined : json['rcsNumber'],
        'oriasNumber': json['oriasNumber'] == null ? undefined : json['oriasNumber'],
        'rcp': json['rcp'] == null ? undefined : json['rcp'],
        'brokerUser': BrokerAbpInfosFromJSON(json['brokerUser']),
    };
}

export function BrokerDtoToJSON(json: any): BrokerDto {
    return BrokerDtoToJSONTyped(json, false);
}

export function BrokerDtoToJSONTyped(value?: BrokerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'legalEntityId': value['legalEntityId'],
        'companyName': value['companyName'],
        'address': AddressDtoToJSON(value['address']),
        'complaintEmail': value['complaintEmail'],
        'phone': value['phone'],
        'registrationNumber': value['registrationNumber'],
        'capital': value['capital'],
        'rcsCity': value['rcsCity'],
        'rcsNumber': value['rcsNumber'],
        'oriasNumber': value['oriasNumber'],
        'rcp': value['rcp'],
        'brokerUser': BrokerAbpInfosToJSON(value['brokerUser']),
    };
}

